import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IMessageService, Message } from '../../../../../sabis-chatbot';

/** Handles message storage and clearing in memory */
@Injectable({
  providedIn: 'root',
})
export class InMemoryMessageService implements IMessageService {
  private _messagesSubject = new BehaviorSubject<Message[]>([]);
  public messages$ = this._messagesSubject.asObservable();

  /**
   * Adds a new message to the in-memory store.
   * If the last message and the new message are both from the chatbot,
   * it merges them by replacing the last one.
   * @param message The message to be added.
   */
  public pushMessage(message: Message): void {
    const currentMessages = this._messagesSubject.value;
    const lastMessage = currentMessages[currentMessages.length - 1];

    let updatedMessages = [...currentMessages];

    if (message.id === lastMessage?.id) {
      updatedMessages[updatedMessages.length - 1] = {
        ...lastMessage,
        ...message,
      };
    } else {
      updatedMessages.push(message);
    }

    this._messagesSubject.next(updatedMessages);
  }

  /** Clears all messages from memory and resets the stream */
  public clearMessages(): void {
    this._messagesSubject.next([]);
  }

  /**
   * Deletes a specific message from the in-memory store based on content and timestamp.
   * @param id The id of the message to be deleted.
   */
  public deleteMessage(id: string) {
    const updatedMessages = this._messagesSubject.value.filter(
      (msg) => msg.id !== id
    );
    this._messagesSubject.next(updatedMessages);
  }
}
